export default class CitiesError extends Error {
  constructor(submessage) {
    super();
    this.name = 'CitiesError';
    this.message = 'Cidade já está cadastrada em outro usuário';
    this.submessage = submessage;
  }
}
